import Head from 'next/head';
import React from 'react';

import { localitySchema } from './HeadStructuredData';
import { IVideoSchema, videoSchema } from './videoSchema';

interface ILocalityHeadProps {
  cityName: string;
  regionCode: string;
  stateName: string;
  rvParkDestination: string;
  hikingTrails: string[];
  video?: IVideoSchema;
}

export const LocalityHead = ({
  cityName,
  regionCode,
  stateName,
  rvParkDestination,
  hikingTrails,
  video,
}: ILocalityHeadProps) => {
  const schemaData = localitySchema({
    cityName,
    regionCode,
    stateName,
    rvParkDestination,
    hikingTrails,
  });

  const videoSchemaData = video
    ? videoSchema({
        name: video.name,
        description: video.description,
        thumbnailUrl: video.thumbnailUrl,
        uploadDate: video.uploadDate,
        duration: video.duration,
        embedUrl: video.embedUrl,
      })
    : null;

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      {videoSchemaData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(videoSchemaData) }}
        />
      )}
    </Head>
  );
};
